//#region src/properties/rejoinCardImages.ts
var e = (e, t) => e.startsWith("http") ? e : `${t}${e}`, t = (t, n) => ({
	...t,
	images: t.images.map((t) => e(t, n)),
	srcsets: t.srcsets?.map((t) => t === null ? null : t.split(", ").map((t) => {
		let [r, i] = t.split(" ");
		return `${e(r, n)} ${i}`;
	}).join(", "))
});
//#endregion
export { t as rejoinCardImages, e as rejoinImagePath };
